var rootStyle = 'search-empty_rootStyle__1qvglkz0';

export { rootStyle };
//# sourceMappingURL=search-empty.vanilla.mjs.map
